// extracted by mini-css-extract-plugin
var _1 = "BlockTypeLabel_mode__0f997";
export { _1 as "mode" }
